import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

export default function DragDropContextWrapper({
  isDragDisabled,
  onDragEnd,
  onDragStart,
  droppableId,
  droppableType,
  children,
}) {
  if (isDragDisabled) {
    return (
      <div style={{ height: '100%', width: '100%' }}>
        {children}
      </div>
    );
  }

  return (
    <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
      <Droppable droppableId={droppableId} type={droppableType}>
        {({ droppableProps, innerRef, placeholder }) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <div
            {...droppableProps}
            ref={innerRef}
            style={{ height: '100%', width: '100%' }}
          >
            {children}
            {placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}

DragDropContextWrapper.propTypes = {
  isDragDisabled: PropTypes.bool,
  onDragEnd: PropTypes.func.isRequired,
  onDragStart: PropTypes.func.isRequired,
  droppableId: PropTypes.string.isRequired,
  droppableType: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

DragDropContextWrapper.defaultProps = {
  isDragDisabled: false,
};

